import { Linking, Pressable, StyleSheet, Text, View } from 'react-native'
import { colors, fontFamily, fontSize, radius, space } from '../tokens'

// EXPO_PUBLIC_API_URL points at /trpc; the public sample PDFs sit alongside
// it at /samples/. Derive the origin once so the preview links resolve to
// whatever environment the app is running against (local dev, preview, prod).
const apiUrl = process.env.EXPO_PUBLIC_API_URL?.trim() ?? 'http://localhost:3000/trpc'
const SAMPLES_BASE = apiUrl.replace(/\/trpc\/?$/, '')
const SAMPLE_LINKS = [
  { label: 'VO 7455 form', href: `${SAMPLES_BASE}/samples/vo7455-sample.pdf` },
  { label: 'Evidence appendix', href: `${SAMPLES_BASE}/samples/evidence-sample.pdf` },
] as const

const openSample = (href: string) => {
  if (typeof window !== 'undefined') {
    window.open(href, '_blank', 'noopener,noreferrer')
    return
  }
  Linking.openURL(href).catch(() => undefined)
}

export const PaidAppealCTAPreview = () => (
  <View style={styles.previews}>
    <Text style={styles.previewLabel}>Preview a redacted sample (opens in a new tab):</Text>
    <View style={styles.previewLinks}>
      {SAMPLE_LINKS.map((link) => (
        <Pressable
          accessibilityRole="link"
          key={link.href}
          onPress={() => openSample(link.href)}
          style={styles.previewLink}
        >
          <Text style={styles.previewLinkText}>{link.label} →</Text>
        </Pressable>
      ))}
    </View>
  </View>
)

const styles = StyleSheet.create({
  previews: {
    marginTop: space[4],
    paddingVertical: space[8],
    paddingHorizontal: space[16],
    backgroundColor: colors.gray[50],
    borderRadius: radius.sm,
    borderWidth: 1,
    borderColor: colors.gray[300],
    gap: space[4],
  },
  previewLabel: {
    fontSize: fontSize.tiny,
    color: colors.gray[700],
    fontFamily: fontFamily.body,
  },
  previewLinks: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: space[16],
  },
  previewLink: {
    paddingVertical: 4,
  },
  previewLinkText: {
    color: colors.primary[700],
    fontSize: fontSize.small,
    fontWeight: '500',
    fontFamily: fontFamily.body,
    textDecorationLine: 'underline',
  },
})
